
{
  "close": "Okay",
"content": "This can take a little while. Keep an eye on your inbox, we will email you when your approval status changes.",
  "heading": "Setting Up Text Message Marketing"
}
